// Store implementation matching PRD functional pattern
type Listener = (state: Record<string, unknown>) => void;

const state: Record<string, unknown> = {};
const listeners = new Set<Listener>();

// Load initial state from localStorage
const stored = localStorage.getItem('lunai_user_data');
// console.log('Loading from localStorage:', stored);
if (stored) {
  try {
    const parsedData = JSON.parse(stored);
    console.log('Parsed localStorage data:', parsedData);
    Object.assign(state, parsedData);

    // Load selfie from separate storage if it was stored
    if (parsedData.selfie === 'stored') {
      const storedSelfie = localStorage.getItem('lunai_selfie');
      if (storedSelfie) {
        state.selfie = storedSelfie;
        console.log('Loaded selfie from separate storage');
      }
    }
  } catch (error) {
    console.error('Failed to load stored state:', error);
  }
}
console.log('Initial store state:', state);

export const store = {
  get: <T = unknown>(key: string): T => state[key] as T,

  set: (key: string, value: unknown): void => {
    console.log(`store.set('${key}', ${JSON.stringify(value)})`);
    state[key] = value;

    // Save to localStorage (excluding large data)
    try {
      const toStore = { ...state };

      // Handle selfie storage separately
      if (key === 'selfie' && value && (value as string).length > 10000) {
        // Store the actual selfie in a separate localStorage key
        localStorage.setItem('lunai_selfie', value as string);
        toStore.selfie = 'stored'; // Mark that we have a selfie stored separately
      } else if (toStore.selfie && typeof toStore.selfie === 'string' && toStore.selfie.length > 10000) {
        // If updating something else but selfie exists, keep the marker
        toStore.selfie = 'stored';
      }

      if (toStore.cameraStream) {
        delete toStore.cameraStream; // Don't store media streams
      }

      localStorage.setItem('lunai_user_data', JSON.stringify(toStore));
    } catch (error) {
      console.error('Failed to save state:', error);
    }

    // Notify listeners
    listeners.forEach(listener => listener(state));
  },

  on: (listener: Listener): (() => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  getAll: (): Record<string, unknown> => ({ ...state }),

  clear: (): void => {
    Object.keys(state).forEach(key => delete state[key]);
    localStorage.removeItem('lunai_user_data');
    localStorage.removeItem('lunai_selfie'); // Also remove the selfie
    listeners.forEach(listener => listener(state));
  }
};